import { renderTableTitle } from "@/utils/render.jsx";
// import { initPurposeHeight } from "@/utils/util.js";
import { ipTablesDelete } from "@/service/structure.js";
export default {
  data() {
    const h = this.$createElement;
    return {
      config: {
        columns: [{
          title: $t("lnjk2", "类型"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "isAllow",
          notShowSearch: true,
          width: 100,
          validate: [{
            required: true,
            message: $t("r5k1og6", "类型不能为空"),
            trigger: "change"
          }],
          renderTable: (h, {
            row
          }) => {
            return h("div", {
              "class": "text-left"
            }, [row.isAllow === "F" ? $t("no6t53", "黑名单") : $t("hrjfp3", "白名单")]);
          },
          renderForm: ({
            value,
            input,
            outData
          }) => {
            let edit = outData.dialogType === "edit";
            let isNew = outData.dialogType === "new";
            let disabled = edit;
            let {
              table
            } = this.$refs["whiteBlackProTable"].getDatas();
            if (isNew) {
              if (table.length > 0) {
                value = table[0].isAllow;
                this.config.form.value.isAllow = value;
                disabled = true;
              }
            }
            return h("RadioGroup", {
              "attrs": {
                "value": value
              },
              "on": {
                "input": input
              }
            }, [h("Radio", {
              "attrs": {
                "disabled": disabled,
                "label": "F"
              }
            }, [$t("no6t53", "黑名单")]), h("Radio", {
              "attrs": {
                "disabled": disabled,
                "label": "T"
              }
            }, [$t("hrjfp3", "白名单")])]);
          }
        }, {
          title: $t("1rkhj4", "IP地址"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "ip",
          align: "left",
          width: 150,
          validate: [{
            required: true,
            message: $t("ov5m4p6", "IP不能为空"),
            trigger: "blur,change"
          }],
          renderForm: ({
            value,
            input
          }) => {
            return h("span", {
              "class": "flex items-center"
            }, [h("Input", {
              "attrs": {
                "value": value,
                "placeholder": $t("wul7gig", "IP地址， 支持具体IP和IP段")
              },
              "on": {
                "input": input
              }
            }), h("Poptip", {
              "attrs": {
                "trigger": "hover",
                "content": $t("itipfwy", "IPv4地址和IPv4地址段 0.0.0.0 或 0.0.0.0/0")
              }
            }, [h("Icon", {
              "attrs": {
                "color": "#2d8cf0",
                "size": 20,
                "type": "ios-help-circle"
              },
              "style": {
                marginLeft: "5px"
              }
            })])]);
          }
        }, {
          title: $t("fqo12", "备注"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "remark",
          notShowSearch: true,
          validate: [{
            pattern: /^.{0,230}$/,
            message: $t("cc0xwq6", "备注超过长度"),
            trigger: "blur,change"
          }],
          tooltip: true
        }, {
          title: $t("chspy3", "创建者"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "createUser",
          width: 100,
          notShowForm: true,
          notShowSearch: true,
          renderTable: (h, {
            row
          }) => {
            return h("div", {
              "class": "text-left"
            }, [h("span", {
              "class": "name"
            }, [row.createUser])]);
          }
        }, {
          title: $t("ar84e54", "创建时间"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "createDatetime",
          notShowForm: true,
          notShowSearch: true
        }, {
          title: $t("c747j3", "修改人"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          width: 100,
          key: "modifyUser",
          notShowForm: true,
          notShowSearch: true,
          renderTable: (h, {
            row
          }) => {
            return h("div", {
              "class": "text-left"
            }, [h("span", {
              "class": "name"
            }, [row.modifyUser])]);
          }
        }, {
          title: $t("ai9edl4", "修改时间"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "modifyDatetime",
          notShowForm: true,
          notShowSearch: true
        }, {
          title: $t("hkxb2", "操作"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "action",
          isAdd: true,
          width: 120,
          notShowSearch: true,
          notShowForm: true,
          actions: [{
            type: "edit",
            title: $t("mekb2", "编辑"),
            request: "/api/ipTables/update",
            method: "POST",
            keys: ["id", "ip", "remark"]
          }, {
            type: "delete",
            title: $t("eslg2", "删除"),
            request: async params => {
              const paramsData = {
                id: params.id
              };
              const res = await ipTablesDelete(paramsData);
              if (res.data && res.data.result === 0) {
                this.$Message.success($t("azeh8z4", "删除成功"));
                let proTableRef = this.$refs[this.config.ref];
                if (proTableRef.proData.length === 1 && proTableRef.page.current > 1) {
                  proTableRef.page.current -= 1;
                }
                this.$refs[this.config.ref].fetch();
              }
            },
            keys: ["id"],
            method: "POST"
          }]
        }],
        search: {
          searchLableWidth: 80
        },
        map: {
          dataPath: "data.retVal.datas",
          totalPath: "data.retVal.totalRows",
          message: "msg"
        },
        format: {
          formatCurrent: "(page.current - 1) * page.pageSize"
        },
        request: "/api/ipTables/query",
        submitForm: "/api/ipTables/save",
        form: {
          labelWidth: 110,
          labelPosition: "top",
          value: {
            isAllow: "F"
          }
        },
        table: {
          border: false,
          height: window.innerHeight - 290
        },
        ref: "whiteBlackProTable"
      }
    };
  },
  mounted() {
    // initPurposeHeight(
    //   this,
    //   {
    //     form: this.config.table,
    //     params: "height",
    //   },
    //   "whiteBlack",
    //   [],
    //   204
    // );
  }
};